import { render, staticRenderFns } from "./LearnNewVideo.vue?vue&type=template&id=e5256d94"
import script from "./LearnNewVideo.vue?vue&type=script&lang=js"
export * from "./LearnNewVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports